import { LoadingState } from '../../../../../state/loading/loading.reducer'
import { startLoadingSpecifications, stopLoadingSpecifications } from '../../../../../state/loading/loading.actions'
import { SharedUserService, SpecificationsService } from '@agroone-front/shared'
import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { catchError, distinctUntilChanged, filter, map, mergeMap, of, skip, tap } from 'rxjs'
import {
  loadSpecifications,
  loadSpecificationsFailure,
  loadSpecificationsSuccess,
} from '../actions/specification.actions'

@Injectable()
export class SpecificationEffects {
  private actions$ = inject(Actions)
  private specificationService = inject(SpecificationsService)
  private loadingStore = inject<Store<LoadingState>>(Store)
  private userService = inject(SharedUserService)

  // Keep specifications in sync when the user switches active region.
  public reloadOnRegionChange$ = createEffect(() =>
    this.userService.user.pipe(
      map((user) => user?.regionName),
      filter((regionName): regionName is string => !!regionName),
      distinctUntilChanged(),
      skip(1),
      map(() => loadSpecifications()),
    ),
  )

  public getSpecifications$ = createEffect(() => {
    this.loadingStore.dispatch(startLoadingSpecifications())

    return this.actions$.pipe(
      ofType(loadSpecifications),
      distinctUntilChanged(),
      mergeMap(() =>
        this.specificationService.getAllSpecForActiveRegion().pipe(
          tap(() => this.loadingStore.dispatch(stopLoadingSpecifications())),
          map((specifications) => loadSpecificationsSuccess({ specifications })),
          catchError((e) => {
            this.loadingStore.dispatch(stopLoadingSpecifications())
            return of(loadSpecificationsFailure({ error: `${e}` }))
          }),
        ),
      ),
    )
  })
}
